import { createSlice } from "@marta/core/features/wizard/slice";

import { FamWizardState } from "./wizard-types";

const initialState: FamWizardState = {};

export const { reducer: wizardReducer } = createSlice({ initialState });
